import React, { lazy } from 'react';
export function EggHatchAnimation() {
  return <div className="w-24 h-24 mx-auto mb-6" data-id="element-46">
      <iframe src="https://lottie.host/embed/e8af02e0-0420-4fbe-b401-1742eef093e9/0Pmj9GftJH.lottie" title="Hatching egg animation" className="w-full h-full border-0 bg-transparent" style={{
      background: 'transparent'
    }} loading="lazy" data-id="element-47" />
    </div>;
}